module.exports = __webpack_public_path__ + "media/icons/chevron-up-c78a44dc.png";